import React from 'react'
import { IAlertProps } from '../../Types/Components'
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

const AlertBox = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Alert = (props: IAlertProps) => {
    return (
        <Snackbar
            anchorOrigin={{
                vertical: "bottom",
                horizontal: props.origin ? props.origin : "center"
            }}
            open={props.open} autoHideDuration={props.duration ? props.duration : 3000} onClose={props.handleClose}>
            <AlertBox onClose={props.handleClose} severity={props.type} sx={{ width: '100%' }}>
                {props.message}
            </AlertBox>
        </Snackbar>
    )
}

export default Alert